import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "compo-api-composables-main" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Options API", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("This is an example of the Options API. We just parse in a "),
  /*#__PURE__*/_createElementVNode("code", null, "message"),
  /*#__PURE__*/_createTextVNode(" variable from the data property in our component.")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Composition API", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("We brought this in from the Composition API! The width is a value generated by a function that lies in ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("code", null, "src/composables/<functionName>.ts", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(". That's how we can easily display the window width ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("right over here")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(", too")

import useWindowWidth from "../composables/useWindowWidth";
import {computed} from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const message = "Hi from Options API!"
const width = useWindowWidth();
const widthDoubled = computed (() => {
  console.log(width)

  return width.value * 2;
});
const reportWidth = () => {
      alert(width);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", null, _toDisplayString(message)),
    _hoisted_4,
    _createElementVNode("p", null, [
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createVNode(_component_router_link, { to: "/home/#width" }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _hoisted_9
    ]),
    _createElementVNode("p", null, _toDisplayString(_unref(width)), 1),
    _createElementVNode("button", { onClick: reportWidth }, "Show Width in Alert Box"),
    _createElementVNode("p", null, _toDisplayString(_unref(widthDoubled)), 1)
  ]))
}
}

})